  
import { useField } from 'formik';
import { ReactElement, SyntheticEvent } from 'react';
import { Form, Label, Checkbox } from 'semantic-ui-react';

interface Props {
    name: string;
    type?: string;
    label: ReactElement<any, any>;
    onChange?: Function;
}

export default function MyCheckInput(props: Props) {
    const [field, meta, helpers] = useField(props.name); 
    const { setValue } = helpers;

    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <Checkbox 
                id={props.name}
                name={props.name} 
                label={props.label} 
                defaultChecked={field.value} 
                onChange={(event: SyntheticEvent, data: any) => {
                    setValue(data.checked);

                    // pass the check value into onchange function
                    if(props.onChange) 
                        props.onChange(data.checked);
                }}
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}